import { useTranslation } from 'react-i18next'
import { hasPrice, hasPriceUnkown } from '../../common/lib/credit'

export const useNoPriceInstructionsText = row => {
  const { t } = useTranslation()

  const text = hasPrice(row)
    ? `${parseInt(row.totalPrice, 10).toLocaleString()} ${row.currency}`
    : hasPriceUnkown(row)
    ? t('omega; hp pricetag - waiting for price, try again in 1 hour')
    : t('omega; hp pricetag - no price yet, click get price button to retrieve price')

  return text
}
